import { useAtom } from '@reatom/npm-react'

import { Numeric } from '@blade/ui-kit'
import { nativeNetworkCurrencyAtom } from '@root/entities/currency'
import { RankCard } from '@root/entities/leaderboard/ui'
import { profileAtom } from '@root/entities/profile'
import { referralBalanceNativeAtom } from '@root/entities/referral'

type RankCardProps = object

export const ReferralRankCard: React.FC<RankCardProps> = () => {
  const [profile] = useAtom(profileAtom)
  const [referralBalance] = useAtom(referralBalanceNativeAtom)
  const [nativeCurrency] = useAtom(nativeNetworkCurrencyAtom)
  const referralRank = profile?.referralRank

  return (
    <RankCard
      rank={referralRank}
      variant="green"
      endContent={
        <Numeric
          value={referralBalance ?? 0}
          preset="currency-amount-short"
          currency={nativeCurrency.ticker}
        />
      }
    />
  )
}
